import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  getNotificationMessage,
  markersSelectors,
  setGoToMinZoomOut,
  usersSelectors
} from 'store'
import {
  REJECTED,
  SUCCEEDED
} from 'utils/constants'
import {
  isAuth,
  isLiteralNumber,
  showCoordParams
} from 'utils/helpers'

import { VerificationCodeModal } from '../Auth/VerificationCodeModal'
import { FiltersData } from './FiltersData'
import { Map } from './Map'
import { StyledContentContainer } from './styled'
import { UsersCount } from './UsersCount'
import { BlogModal } from './BlogModal'
import { EventModal } from './EventModal'
import { ImageCarouselModal } from './ImageCarouselModal'

export const Content = () => {
  const dispatch = useDispatch()
  const mapRef = useRef()

  const [visibleMarkersCount, setVisibleMarkersCount] = useState([])
  const [alreadyRun, setAlreadyRun] = useState(false)
  const [showMarkerCount, setShowMarkerCount] = useState('flex')
  const zoom = localStorage.getItem('zoom')

  const {
    eventData,
    eventMarkers,
    getEventMarkersStatus,
    getMarkersStatus,
    markers,
    isImageCarouselOpen
  } = useSelector(markersSelectors)
  const {
    activeProfile,
    getUserProfileStatus,
    openPopupEvents,
    userProfile
  } = useSelector(usersSelectors)

  const [searchParams, setSearchParams] = useSearchParams()

  const id = searchParams.get('id')
  const eventid = searchParams.get('eventid')

  const goToMinZoomOut = () => dispatch(setGoToMinZoomOut(true))

  if (id !== null && eventid === null) {
    if (isLiteralNumber(id)) {
      sessionStorage.setItem('id', id)

      if (
        !isAuth()
        && searchParams.get('from') === 'qrcode'
      ) {
        sessionStorage.setItem('sendConnReqTo', id)
      }

      if (searchParams.get('from') === 'qrcode') {
        setSearchParams({ id })
      }
    } else {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Invalid URL parameters',
          isEditProfile: true
        })
      )
    }
  } else if (eventid !== null && id === null) {
    if (isLiteralNumber(eventid)) {
      sessionStorage.setItem('eventid', eventid)
    } else {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Invalid URL parameters',
          isEditProfile: true
        })
      )
    }
  }

  useEffect(() => {
    if (
      getEventMarkersStatus === SUCCEEDED
      && activeProfile
      && !alreadyRun
      && !openPopupEvents
    ) {
      setAlreadyRun(true)
      const findThisEventId = sessionStorage.getItem('eventid')

      if (findThisEventId) {
        const foundEvent = eventMarkers.find((e) => e.id === Number(findThisEventId))

        if (
          !foundEvent
          || (
            foundEvent?.id
            && !activeProfile?.affinities.some((a) => a.title === foundEvent?.affinities)
          )
        ) {
          sessionStorage.removeItem('eventid')

          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: `Event id#${findThisEventId} is unavailable`,
              isEditProfile: false
            })
          )

          setTimeout(() => showCoordParams(setSearchParams), 500)
        }
      }
    }
  }, [getEventMarkersStatus, activeProfile])

  useEffect(() => {
    if (
      getMarkersStatus === SUCCEEDED
      && getUserProfileStatus === SUCCEEDED
      && !alreadyRun
    ) {
      setAlreadyRun(true)
      const findThisProfileId = sessionStorage.getItem('id')

      if (findThisProfileId) {
        const foundMarker = markers.find((m) => m.id === Number(findThisProfileId))
        const foundUserProfile = userProfile.find((up) => up.id === Number(findThisProfileId))

        if (
          !foundMarker
          && !foundUserProfile
        ) {
          sessionStorage.removeItem('id')

          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: `Profile id#${findThisProfileId} is unavailable`,
              isEditProfile: false
            })
          )

          showCoordParams(setSearchParams)
        }
      }
    }
  }, [getMarkersStatus, getUserProfileStatus])

  return (
    <StyledContentContainer>
      <VerificationCodeModal />
      <Map
        mapRef={mapRef}
        setVisibleMarkersCount={setVisibleMarkersCount}
        setShowMarkerCount={setShowMarkerCount}
      />
      <FiltersData showMarkerCount={showMarkerCount} />
      <UsersCount
        mapRef={mapRef}
        visibleMarkersCount={visibleMarkersCount}
        showMarkerCount={showMarkerCount}
        zoom={zoom}
        goToMinZoomOut={goToMinZoomOut}
      />
      <BlogModal />
      <EventModal />
      {eventData?.additional_images && isImageCarouselOpen === true ? <ImageCarouselModal /> : null}
    </StyledContentContainer>
  )
}
